import { render, staticRenderFns } from "./app-ad.vue?vue&type=template&id=6288c900"
import script from "./app-ad.vue?vue&type=script&lang=js"
export * from "./app-ad.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/johnson/WebStormProject/zm/zm-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6288c900')) {
      api.createRecord('6288c900', component.options)
    } else {
      api.reload('6288c900', component.options)
    }
    module.hot.accept("./app-ad.vue?vue&type=template&id=6288c900", function () {
      api.rerender('6288c900', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/system-management/ad-management/app-ad.vue"
export default component.exports